import styled from "styled-components";

export const Placeholder = styled.div`
  height: 100%;
`;
